import axios from "axios";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import router from "@/router";
import { pesanGagalJaringan } from "@/utils/gagalJaringan";

const API_URL = process.env.VUE_APP_API_PANGGILAN_POLI;

const instance = axios.create({
  baseURL: API_URL,
  timeout: 20000,
  params: {} // do not remove this, its added to add params later in the config
});

// Add a request interceptor
instance.interceptors.request.use(
  function(config) {
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => response,
  error => {
    if (!error.response) {
      appModule.NoticeDelayAlert(pesanGagalJaringan(error.config?.method));
    } else if (error.response.status === 401) {
      userModule.logout();
      router.push({
        path: "/login",
        params: { message: "Autentikasi User gagal atau sesi Anda telah habis" }
      });
    }

    return Promise.reject(error);
  }
);

export default {
  getAPI() {
    const url = `${API_URL}`;
    return url;
  },
  getData(endpoint, data = null) {
    let url = `${API_URL}`;
    url += endpoint;

    return instance.get(url, data);
  },
  getDataParam(endpoint, data) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.get(url, data);
  },
  postData(endpoint, data) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.post(url, data);
  },
  putData(endpoint, data) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.put(url, data);
  },
  deleteData(endpoint, data) {
    let url = `${API_URL}`;
    url += endpoint;
    const config = {
      data
    };

    return instance.delete(url, config);
  },
  login(endpoint, data) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.get(url, data);
  },
  apiUrl: API_URL
};
